const date = new Date();
const currentMonth = date.getMonth();
const currentSeason = currentMonth < 10 ? date.getFullYear() : date.getFullYear() + 1;

module.exports = { currentSeason };
